import { IPlaylistVideos } from '../interfaces/IPlaylistVideos';

export const PlayListPromoverAlfabetizacao: IPlaylistVideos[] = [
    {
        title: 'A escrita como instrumento histórico de cidadania e objeto de políticas públicas',
        idVideo: 'ywCIoO897SQ',
        description: '',
    },
    {
        title: 'As etapas do processo de alfabetização na perspectiva da BNCC',
        idVideo: 'mapyuOLIk0U',
        description: '',
    },
    {
        title: 'Letramentos e multiletramentos no processo de alfabetização',
        idVideo: 'MNVfvzawtLg',
        description: '',
    },
    {
        title: 'Os fundamentos da alfabetização (concepções de ensino e práticas)​',
        idVideo: 'vCvbNjXb9yw',
        description: '',
    },
    {
        title: 'Avaliação formativa​',
        idVideo: 'GthPHsJkTGs',
        description: '',
    },
    {
        title: 'Dificuldades de aprendizagem e as práticas de superação​',
        idVideo: '5WGUWraJSL0',
        description: '',
    },
    {
        title: 'Avaliação e Monitoramento​',
        idVideo: 'rIvF1fL5gwA',
        description: '',
    },
    {
        title: 'Cultura digital na alfabetização​',
        idVideo: 'tCWBV-cguvg',
        description: '',
    },
    {
        title: '​A importância da formação de professores alfabetizadores',
        idVideo: 'lxp3lhcf_gk',
        description: '',
    },
    {
        title: 'A educação infantil e sua conexão com a alfabetização​',
        idVideo: 'dWwg6lYa1h4',
        description: '',
    },
];
